<template>
  <div class="bg-F2F2F6 pt-12 relative">
    <div class="p-0-16 p-16-0 pb-136 scroll-y">
      <div
        class="font-28 p-3-0 c-111F2C face-rule"
        v-for="item in rules"
        :key="`list-${item}`"
        v-html="item"
      ></div>
    </div>
    <div class="footer h-120 pb-16">
      <div
        class="fb fb-row fb-cross-center fb-main-start pt-16 pb-30"
        @click="agree = !agree"
        ><span
          class="iconfont font-28 pr-8"
          :class="agree ? 'c-006AFE' : 'c-171A1D-24'"
          >{{ agree ? '&#xe66e;' : '&#xe66f;' }}</span
        ><span class="font-24"
          >我已认真阅读并同意魔点-儿童生物识别服务规则</span
        ></div
      >
      <div class="item-flex-1 fb fc-cross-center fb-main-center width-full">
        <md-button
          v-show="showCancel"
          class="mr-16"
          type="cancel"
          @click="handlerCancel"
          >取消</md-button
        >
        <md-button @click="handlerAgree" :disabled="!agree">确认</md-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      agree: false,
      rules: [
        '<p class="text-center text-bold font-32">生物识别信息处理规则</p>',
        '生效日期：2023年8月8日',
        '本规则适用于境内注册并使用魔点生物识别产品和服务的用户（港澳台地区除外）。',
        '本规则仅适用于杭州魔点科技有限公司（“我们”或“魔点”） 所提供的魔点生物识别产品和服务。',
        '如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：',
        '联系电话：4000337675',
        '联系地址：浙江省杭州市余杭区五常街道三维智汇中心3幢A单元7层杭州魔点科技有限公司客户服务部收',
        '您的信任对我们非常重要，我们深知个人信息对您的重要性，我们承诺将按行业成熟的安全标准，采取相应的安全保护措施来保护您的生物识别信息，尽力采用通俗易懂的文字表述向您进行说明和告知，并就本政策中可能与您的合法利益存在重大关系的条款，采用字体加粗的方式以提请您的注意。我们强烈建议您在使用我们的服务前，仔细阅读并完全理解本政策中的全部内容。我们将根据您的选择，为您提供魔点生物识别产品及服务。为此，我们将按照本规则来向用户提供基于生物识别信息的相关服务。“生物识别信息”是指可以用来区分自然人个体的独特生理特征，例如面部图片、面部特征、动态视频、指纹等。生物识别信息属于敏感个人信息。',
        '<p class="text-bold">一 、魔点生物识别服务</p>',
        '1.1 魔点“人脸识别算法服务”是我们提供的通过人脸比对、人脸检索、活体检测等方式来核验您的身份并且用于完成您在所在组织系统/应用的帐号鉴权和使用的服务（以下简称“本服务”）。魔点公司将依照您所在组织的指示，将人脸识别的验证结果传送给您所在的组织，以实现身份核验和鉴权。当您所在的组织通过本服务实现自建系统/应用以及内嵌魔点服务的三方应用的帐号鉴权时，您同意您所在的组织基于管理目的安排您通过魔点客户端录入人脸照片，以便魔点提取和处理您的人脸特征值以便实现人脸识别服务。',
        '1.2魔点智能硬件“生物识别”功能是我们提供的通过指纹比对/人脸比对的方式来核验您的身份并且根据业务权限设置执行特定的操作，例如打开门禁、完成考勤打卡、完成访客签到等等。',
        '当您所在的组织购买并部署、使用魔点自有品牌硬件，包括魔点智能指纹考勤门禁机、魔点智能人脸考勤机、魔点智能人脸考勤门禁机、魔点智能人脸身份自证机、魔点人脸识别智慧终端等，以及内嵌魔点服务的集成智能硬件以实现指纹/人脸识别服务的智能硬件产品的情况下，您同意您所在的组织基于管理目的安排您通过魔点客户端或者硬件设备录入指纹或人脸照片，以便魔点提取和处理您的指纹特征值或人脸特征值以便实现指纹识别或人脸识别服务。',
        '1.3其他设备厂商的生物识别功能',
        '当您所在的组织选择了其他设备厂商提供的生物识别功能，您理解对您生物识别信息的采集、存储和比对等服务将由您使用的设备及其系统来完成。一般而言，此类设备可以将用户的生物识别信息与事先录入并存储在该设备上的特征数据进行比对核验。在按照您所使用的设备的要求在业务系统内开通相应的生物识别功能并录入有效的生物识别信息后，您可通过该设备接受第三方的服务，在这种情况下，您的生物识别信息的使用和管理将由该第三方提供。请您选择您信任的设备使用生物识别功能，若您对您使用的设备或生物识别功能存有疑虑，我们建议您使用其他技术方式。',
        '1.4您理解并同意，本服务由您所在组织选择开通，若您选择使用或关闭人脸服务，请您联系您所在的组织的管理员为您关闭人脸识别服务并选择其他的鉴权方式。',
        '<p class="text-bold">二、儿童生物识别服务特别规则</p>',
        '2.1我们深知儿童（未满十四周岁的未成年人）个人信息的重要性，我们将按法律法规要求并参照行业最佳实践为您孩子的个人信息安全提供充分保障。',
        '2.2魔点教育教学相关的智能门禁、班牌、通话机服务',
        '2.2.1当您孩子所在的学校购买并部署、使用魔点自有品牌硬件以及内嵌魔点服务的集成智能硬件以实现基于人脸识别服务的智能硬件产品的情况下，您同意您孩子所在的学校基于教学管理目的安排您通过魔点客户端或者硬件设备录入您孩子的人脸照片 ，以便魔点提取和处理您孩子的人脸特征值以便实现基于人脸识别的智能门禁、班牌、通话机服务。',
        '2.2.2您可选择使用或关闭上述服务，请您联系您孩子所在学校的管理员为您关闭基于人脸识别的智能门禁、班牌、通话机服务并选择其他措施。',
        '2.3其他设备厂商的生物识别功能',
        '2.3.1当您孩子所在的学校选择了其他设备厂商提供的生物识别功能，您理解对您孩子生物识别信息的采集、存储、和比对等服务将由您使用的设备及其系统来完成。一般而言，此类设备可以将用户的生物识别信息与事先录入并存储在该设备上的特征数据进行比对核验。',
        '2.3.2在按照您所使用的设备的要求在设备操作系统内开通相应的生物识别功能并录入有效的您的孩子的生物识别信息后，您的孩子的生物识别信息的使用和管理将由该第三方提供。请您选择您信任的设备使用生物识别功能，若您对您使用的设备或生物识别功能存有疑虑，我们建议您使用其他技术方式。',
        '<p class="text-bold">三、风险及免责:</p>',
        '3.1您理解并同意，在您使用本服务时，须自行承担如下杭州魔点科技有限公司不可掌控的风险内容，包括但不限于：',
        '3.1.1由于受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏等不可抗拒因素可能引起的信息错误、验证失败等风险；',
        '3.1.2由于技术限制、恶意提交非真实照片/身份信息、服务超载/不稳定、传送延迟/中断、服务器故障等客观因素可能引起的信息错误、验证失败等风险；',
        '3.1.3由于您操作不当或通过非魔点授权的方式使用本服务，以及其他魔点无法控制或合理预见所导致的信息错误、验证失败等风险。',
        '<p class="text-bold">四、为您优化服务的体验</p>',
        '为向您提供更好的生物识别服务，降低服务的误识率，提高服务的效率，我们会对人脸识别算法进行训练升级。在算法训练的过程中，会将您的人脸信息进行去标识化处理，以便算法训练中无法识别您个人。',
        '<p class="text-bold">五、其他</p>',
        '为了进一步改善用户体验，我们将会持续更新服务，为用户提供版本升级、功能升级等服务和内容的更新，本规则也可能会随之更新，更新内容将于公布之日起生效。若您不同意更新后的条款内容，您有权停止使用相关服务，您选择停止相关服务的情况下，请联系您所在的组织的管理员为您关闭该服务。',
        '<p class="text-right">杭州魔点科技有限公司</p>'
      ]
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerAgree() {
      this.$emit('agree')
    },
    handlerCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.face-rule {
  text-indent: 26px;
}
:deep(.md-button--cancel) {
  color: rgb(25, 26, 38, 0.6) !important;
}
</style>
